<template>

  <div class="Mflow-container">
    <VueFlow :nodes="nodes" :edges="edges" :zoom-on-double-click="false" @dragover="minowDragOver" @drop="minowDrop"
      @dragleave="minowDragLeave" :connection-mode="ConnectionMode.Strict" @node-double-click="minowNodeDoubleClick"
      @connect="minowConnect" @node-drag-stop="minowNodeDragStop" @edges-change="minowEdgesChange"
      @nodes-change="minowNodeChange" :max-zoom="maxZoom" :min-zoom="minZoom" :default-viewport="{ zoom: 0.9 }"  :style="{ 'pointer-events': 'auto' }"
      class="Mflow-vueFlow">
      <Background :pattern-color="themeManager?.getCurrentTheme().variables['Mflow-bg-color']"
        :gap="backgroundGap ?? themeManager?.getCurrentTheme().variables['Mflow-bg-gap']" />
      <MiniMap v-if="showMiniMap"
        :maskColor="themeManager?.getCurrentTheme().variables['Mflow-minimap-bg']"
        :nodeClassName="'Mflow-miniMap-node'" :zoomable="true" :pannable="true"  />
      <template v-for="(values, key) in nodeManager.getAllNodes()" :key="key" #[`node-${key}`]="props">
        <component :is="values.component" v-bind="props" :node="props" />
      </template>
      <template #connection-line="{ sourceX, sourceY, targetX, targetY }">
        <ConnectionLine :source-x="sourceX" :source-y="sourceY" :target-x="targetX" :target-y="targetY"
          sourcePosition="right" targetPosition="left" />
      </template>

    </VueFlow>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { provide, onMounted, watch, type PropType, computed } from 'vue';
import { VueFlow, useVueFlow, ConnectionMode } from '@vue-flow/core';
import { MiniMap } from '@vue-flow/minimap';
import { Background } from '@vue-flow/background';
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@vue-flow/minimap/dist/style.css'
import ConnectionLine from '../common/ConnectionLine.vue';
import * as events from '@components/flow/services/event/events'
import * as drag from '@components/flow/services/event/drag'






// import ConnectionLine from '@/components/lines/connectionLine.vue';
const { getViewport } = useVueFlow();

const props = defineProps({

  // 数据�?
  nodes: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  edges: {
    type: Array as PropType<any[]>,
    default: () => []
  },


  // 节点列表显示拖拽事件
  onDragStart: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  onDragOver: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  onDrop: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  onDragLeave: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  // 节点相关
  onNodeDragStop: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  onNodeChange: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  onEdgesChange: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  nodeDoubleClick: {
    type: Function as PropType<(event: Event) => void>,
    default: () => { },
    required: false
  },
  findNode: {
    type: Function as PropType<(id: string) => any>,
    default: () => { }
  },
  updateNode: {
    type: Function as PropType<(id: string, data: any) => void>,
    default: () => { }
  },
  updateNodeData: {
    type: Function as PropType<(id: string, data: any) => void>,
    default: () => { }
  },
  addNode: {
    type: Function as PropType<(node: any) => void>,
    default: () => { }
  },
  removeNode: {
    type: Function as PropType<(id: string) => void>,
    default: () => { }
  },

  moveNode: {
    type: Function as PropType<(id: string, position: any) => void>,
    default: () => { }
  },
  // edges相关
  addEdge: {
    type: Function as PropType<(edge: any) => void>,
    default: () => { }
  },
  removeEdge: {
    type: Function as PropType<(id: string) => void>,
    default: () => { }
  },
  // 连线相关

  onConnect: {
    type: Function as PropType<(connection: any) => void>,
    default: () => { },
    required: false
  },

  // 节点管理�?
  nodeManager: {
    type: Object as PropType<any>,
    default: () => { }
  },
  // 主题相关
  themeManager: {
    type: Object as PropType<any>,
    default: () => { }
  },

  // 背景相关
  backgroundGap: {
    type: Number as PropType<number>,
    required: false
  },
  // 缩放相关
  maxZoom: {
    type: Number as PropType<number>,
    default: () => 1
  },
  minZoom: {
    type: Number as PropType<number>,
    default: () => 0.1
  },

  // 控制是否显示小地图（由父组件根据右侧面板显隐传入）
  showMiniMap: {
    type: Boolean as PropType<boolean>,
    default: true
  },

  setActiveNodeId: {
    type: Function as PropType<(id: string) => void>,
    default: () => { }
  }
});

onMounted(() => {

})
function minowDragOver(event: DragEvent) {
  props?.onDragOver?.(event)
  drag.onDragOver(event)

}

function minowDrop(event: DragEvent) {

  let viewport = getViewport()
  props?.onDrop?.(event)
  drag.onDrop(event, viewport, props?.addNode)
  // onDrop handled
}


function minowDragLeave(event: DragEvent) {
  props?.onDragLeave?.(event)
  drag.onDragLeave(event)

}

function minowConnect(event: ConnectEvent) {
  // onConnect handled
  let currentTheme = props.themeManager?.getCurrentTheme().variables
  let edgeOptions = {
    lineColor: currentTheme['Mflow-line-color'] ? currentTheme['Mflow-line-color'] : '#000',
    lineWidth: currentTheme['Mflow-line-width'] ? currentTheme['Mflow-line-width'] : '1',
    arrowColor: currentTheme['Mflow-arrow-color'] ? currentTheme['Mflow-arrow-color'] : '#000',

  }

  props?.onConnect?.(event)
  events.onConnect(event, props.addEdge, props.findNode, props.edges, edgeOptions)

}

function minowNodeDragStop(event: NodeDragStopEvent) {
  props?.onNodeDragStop?.(event)
  events.onNodeDragStop(event, props?.moveNode)

}

function minowEdgesChange(event: EdgesChangeEvent) {
  props?.onEdgesChange?.(event)
  events.onEdgesChange(event, props?.removeEdge)

}

function minowNodeChange(event: NodeChangeEvent) {
  props?.onNodeChange?.(event)
  events.onNodeChange(event, props?.removeNode)

}

function minowNodeDoubleClick(event: NodeDoubleClickEvent) {
  props?.nodeDoubleClick?.(event)
  events.nodeDoubleClick(event, props?.setActiveNodeId)

}


// Provide original values
provide('nodeManager', props.nodeManager);
// make nodes/edges reactive for inject consumers
const nodesRef = computed(() => props.nodes)
const edgesRef = computed(() => props.edges)
provide('nodes', nodesRef);
provide('edges', edgesRef);

// Provide workflow methods to child components
provide('updateNodeData', props.updateNodeData);
provide('updateNode', props.updateNode);
provide('addNode', props.addNode);
provide('findNode', props.findNode);
provide('removeNode', props.removeNode);
provide('addEdge', props.addEdge);
provide('removeEdge', props.removeEdge);
provide('moveNode', props.moveNode);
provide('setActiveNodeId', props.setActiveNodeId);

</script>

<style lang="scss">
.Mflow-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.Mflow-vueFlow {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: var(--Mflow-container-bg);
}

rect.Mflow-miniMap-node {
  width: 100px !important;
  height: 50px !important;
  fill: var(--Mflow-minimap-node-color);
}

.vue-flow__minimap {
  position: absolute;
  top: 10px;
  right: 10px;
  left: auto;
  bottom: auto;
  z-index: 900;
    height: 160px;
  >svg {
    background-color: var(--Mflow-minimap-container-bg);
   /* 明确设置小地图高度，按需可再调整 */
  }

  background-color: var(--Mflow-minimap-bg);
  padding: 2px;
}
</style>
